import {
  Exchange,
  Side,
  BitfinexTradeData,
  BitflyerTradeData,
  BitmexTradeData,
  AlertData,
  TickDirection,
  Trade,
} from '@/types/trade';
import { Trades } from './Trades';
import { EventEmitter } from 'events';

const MAINTAIN_PERIOD = 60000;
const ALERT_PERIOD = 10000;
const BITFINEX_ALERT_VOLUME = 70;
const BITFLYER_ALERT_VOLUME = 150;
const BITMEX_ALERT_VOLUME = 200;

const bitfinexConvertTrade = (trade: BitfinexTradeData) => {
  const [id, timestamp, size, price] = trade;
  const vcSide = size > 0 ? Side.BUY : Side.SELL;
  const vcSize = Math.abs(size);
  const newTradeData: Trade = {
    id,
    exchange: Exchange.Bitfinex,
    side: vcSide,
    price,
    size: vcSize,
    timestamp,
  };
  return newTradeData;
};

const bitflyerConvertTrade = (trade: BitflyerTradeData) => {
  const { id, side, price, size, exec_date } = trade;
  const timestamp = Date.parse(exec_date);
  const newTradeData: Trade = {
    id,
    exchange: Exchange.Bitflyer,
    side: side as Side,
    price,
    size,
    timestamp,
  };
  return newTradeData;
};

const bitmexConvertTrade = (trade: BitmexTradeData) => {
  const { trdMatchID, side, price, size, tickDirection, timestamp } = trade;
  const formatedSize = size / price;
  const vcSide = side === 'Buy' ? Side.BUY : Side.SELL;
  const vcTimestamp = Date.parse(timestamp);
  let direction: number;
  if (tickDirection === TickDirection.PlusTick) {
    direction = 1;
  } else if (tickDirection === TickDirection.MinusTick) {
    direction = -1;
  } else {
    direction = 0;
  }
  const newTradeData: Trade = {
    id: trdMatchID,
    exchange: Exchange.Bitmex,
    side: vcSide,
    price,
    size: formatedSize,
    direction,
    timestamp: vcTimestamp,
  };
  return newTradeData;
};

export class TradesService extends EventEmitter {
  private bitfinex = new Trades(
    Exchange.Bitfinex,
    MAINTAIN_PERIOD,
    ALERT_PERIOD,
    BITFINEX_ALERT_VOLUME,
  );
  private bitflyer = new Trades(
    Exchange.Bitflyer,
    MAINTAIN_PERIOD,
    ALERT_PERIOD,
    BITFLYER_ALERT_VOLUME,
  );
  private bitmex = new Trades(
    Exchange.Bitmex,
    MAINTAIN_PERIOD,
    ALERT_PERIOD,
    BITMEX_ALERT_VOLUME,
  );
  constructor() {
    super();
    this.bitfinex.on('alert', (alertData: AlertData) => {
      this.emit('alert', alertData);
    });
    this.bitfinex.on('alert', (alertData: AlertData) => {
      this.emit('alert', alertData);
    });
    this.bitmex.on('alert', (alertData: AlertData) => {
      this.emit('alert', alertData);
    });
  }
  public addBitfinexTrade(trade: BitfinexTradeData) {
    this.bitfinex.addTrade(bitfinexConvertTrade(trade));
  }
  public addBitflyerTrade(trade: BitflyerTradeData) {
    this.bitflyer.addTrade(bitflyerConvertTrade(trade));
  }
  public addBitmexTrade(trade: BitmexTradeData) {
    this.bitmex.addTrade(bitmexConvertTrade(trade));
  }
  public getExchangeTrades() {
    return {
      bitfinex: this.bitfinex,
      bitflyer: this.bitflyer,
      bitmex: this.bitmex,
    };
  }
}
